import React, { Component } from 'react';

import { Table, Modal } from 'antd';

import components from '../../../components';
import SelectInput from '../../../components/selectinput';

import services from '../../../services';
import layouts from '../../../layouts';

import utils from '../../../utils';


class Query extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            employeeData: {},
        };

    }

    componentDidMount() {
        this.getEmployeeData();
    }

    getEmployeeData() {
        services.home.home.employeeData().then(employeeData => {
            this.setState({
                employeeData
            });
        });
    }

    toggleHandle() {
        this.setState({
            toggble: !this.state.toggble
        });
    }

    render() {
        return (
            <layouts.ViewPort>
                <div className="root-panel-wrapper" style={{ width: '100%'}}>
                    <div class="root-graph-view" style={{ width: '100%',padding: '10px'}}>
                        <div style={{width: '30%',float:'left'}}>
                            <div style={{width: '15%',height:'15%',borderRadius: '50%',backgroundColor: 'white',float:'left'}}>
                                <img style={{width: '100px',height:'100px'}} src={'https://avatars1.githubusercontent.com/u/8186664?s=460&v=4'}/>
                                
                            </div>
                            <div style={{width: '70%',float:'right',textAlign:'center',padding: '8%'}}>
                                <table>
                                    <tr>
                                        <td>
                                            姓名：
                                        </td>
                                        <td>
                                            {this.state.employeeData.realName}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            工号：
                                        </td>
                                        <td>
                                            {this.state.employeeData.employeeCode}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div style={{width: '70%',height:'30%',float: 'right',textAlign: 'left',padding: '2%'}}>
                            <table>
                                <tr>
                                    <td>
                                        职称：
                                    </td>
                                    <td>
                                        {this.state.employeeData.title}
                                    </td>
                                    <td>
                                        年龄：
                                    </td>
                                    <td>
                                        {this.state.employeeData.age}
                                    </td>
                                    <td>
                                        类型：
                                    </td>
                                    <td>
                                        {this.state.employeeData.teacherProperty}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        教育背景：
                                    </td>
                                    <td>
                                        {this.state.employeeData.eduDegree}
                                    </td>
                                    <td>
                                        毕业院校：
                                    </td>
                                    <td>
                                        {this.state.employeeData.eduSchool}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </layouts.ViewPort>
        )
    }
}

export default Query;